/* eslint-disable array-callback-return */
import React, { useState, useContext } from 'react';
import io from "socket.io-client";
import API_HOST from '../../../shared/utils/ApiHost';
import { store } from "../../App/store";
//import { makePick, returnPick } from '../../../shared/utils/socket.js';

const PlayerCard = (props) => {
    const globalState = useContext(store)
    //const { dispatch } = globalState;
    const { isAdmin, isMyTurn, current_pick } = globalState.state;
    const [toggle, setToggle] = useState(false);
    const [display, setDisplay] = useState(false);
    const clickClass = toggle ? 'clicked' : '';
    const currentDisplay = display ? 'none' : 'block';
    let showSelect = isMyTurn || isAdmin;
    const player = props.player;

    var fname = player.player.split(",")[1].trim();
    var lname = player.player.split(",")[0].trim();
    var name = `${fname} ${lname}`;

    const makePick = () => {
        setDisplay(!display);
        const socket = io(API_HOST,{
            withCredentials: true,
            extraHeaders: {
                "room": "urb_2002"
            }
        });
        socket.emit('draft_player',{pickNumber: current_pick, playerSelected: player.pid})
    }

    const returnPick = () => {
        setDisplay(!display);
        const socket = io(API_HOST,{
            withCredentials: true,
            extraHeaders: {
                "room": "urb_2002"
            }
        });
        socket.emit('return_player',{pickNumber: current_pick, playerSelected: player.pid, newTeam: 0})
    }

    return  (
        <li id={`player-` + player.pid} data-pname={name} data-pid={player.pid} className={`player player-` + player.pid + ' ' + clickClass} data-team={player.team} data-playername={name} style={{display: currentDisplay}} onClick={() => setToggle(!toggle)}>
            <div className="player-nameschool">
                <span className="playername"><span className="overall-rank">{player.pid}</span> {name}</span> - <span className="school">{player.school}</span>
                <span className="return-pick" onClick={() => returnPick(player, current_pick)} >✖</span>
            </div>
            <div className="player-info">
                <h4>{name} - {player.school}</h4>
                <div className="stats">
                    <span><strong>Seed</strong><br />{player.seed}</span>
                    <span><strong>Pts</strong><br />{player.pts}</span>
                    <span><strong>FG%</strong><br />{player.fg}</span>
                    <span><strong>3P%</strong><br />{player["3p"]}</span>
                    <span><strong>FT%</strong><br />{player.ft}</span>
                </div>
                {showSelect && 
                    <div className="buttons"><div className="selectbtn" onClick={() => makePick(player, current_pick)}>Select</div></div>
                }
            </div>
        </li>
    )
};

export default PlayerCard;